import React from 'react';
import { NavLink } from 'react-router-dom';
import classnames from 'classnames';
import { MBR_POLICY_PATH } from '@utils/constants';
import globalStyles from '../index.less';

const MbrTab = () => (
  <NavLink
    id="tab-mbr-policies"
    key="mbr-policies"
    to={`${MBR_POLICY_PATH}`}
    className={({ isActive }) => classnames(globalStyles.tab, { [globalStyles.active]: isActive })}
    end
  >
    Experience Policies
  </NavLink>
);

export default MbrTab;
